import { RESET_USER_DATA, SET_USER_DATA } from "../actionTypes/userProfile";

export const setUserAction = user => ({
  type: SET_USER_DATA,
  payload: { user }
});

export const resetUserAction = user => ({ type: RESET_USER_DATA });
